import * as React from 'react'
// CComponents
import {H1} from '@frontrow/console/src/components/typography'

import RosterItem from '@frontrow/console/src/components/pages/roster-page/roster-item'

export default function RosterPageContainer(): React.ReactElement {
  /* Will be Dark launch on merge: expose import-sis-ids page after error messages are updated*/
  return (
    <React.Fragment>
      <H1>Rostering</H1>
      <RosterItem
        url="/import-sis-ids"
        title="Import SIS IDs"
        description="Add SIS IDs to existing students in Freckle (does not create any new students)"
      />
      <RosterItem
        url="/roster-sync"
        title="Sync Rosters"
        description="Create and update students in Freckle to match a district's rosters"
        warning="Make sure SIS IDs have been imported before syncing rosters"
      />
      <RosterItem
        url="/idp-overlay-students"
        title="IdP Overlay"
        description="Add Freckle specific modifications to IdP data."
        warning="This should be used as a last resort. Fixing data in the SIS is preferred."
      />
    </React.Fragment>
  )
}
